import { useEffect, useState } from "react";
// import { Document, Page, pdfjs } from "react-pdf";
import { BiX } from "react-icons/bi"
import styled from "styled-components";
import { FaExternalLinkAlt } from "react-icons/fa";
// import { BsXSquareFill } from "react-icons/bs";

// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`;

interface ModalProps {
  children: any[];
  isModalOpen: boolean;
  onClose(): void;
}

interface ContentProps {
  isOpen: boolean;
}

interface BodyProps {
  isBlue?: boolean;
}

export function Modal({ children, isModalOpen, onClose }: ModalProps) {
  const [isOpen, setIsOpen] = useState(isModalOpen);
  const [numPages, setNumPages] = useState<number | null>(null);

  const url: string = (children?.find(({ key }: any) => key === 'url'))?.ref;

  const options = {
    cMapUrl: 'cmaps/',
    cMapPacked: true,
    standardFontDataUrl: 'standard_fonts/'
  };

  const onDocumentLoadSuccess = ({ numPages: nextNumPages }: any) => {
    setNumPages(nextNumPages);
  }

  const KNOWN_HOSTS = ['onda.org.br', 'cdn.onda.org.br', 'ibdautoral.org.br', 'db1vam0cwczau.cloudfront.net'];

  const isLocalFile = (url: string) => {
    if (!url) return false;
    return KNOWN_HOSTS.some(host => url.includes(host));
  };

  useEffect(() => {
    setIsOpen(isModalOpen);
  }, [isModalOpen]);

  return (
    <Content isOpen={isOpen}>
      <Overlay onClick={() => {
          setIsOpen(false);
          onClose();
        }} />
      <Inner>
        <Close onClick={() => {
          setIsOpen(false);
          onClose();
        }}>
          <BiX size={52} />
        </Close>
        <Header>
          {children?.map(({ key, props }: any) => { // eslint-disable-line array-callback-return
            const title = props?.children?.find(({ type }: any) => type === 'span');
            const content = props?.children?.find(({ type }: any) => type === 'section');

            if (key !== 'url') {
              return (
                <Item>
                  <Title>{title}</Title>
                  <ItemContent>{content}</ItemContent>
                </Item>
              );
            }
          })}
        </Header>
        <TextLinkBody>
          <TextLink hidden={!isLocalFile(url)} href={url} target="_blank" >
            Clique para acessar em nova aba e fazer download &nbsp; <FaExternalLinkAlt size={15} />
          </TextLink>
        </TextLinkBody>
        {/*<Body>
          { isOpen && isLocalFile(url)? (
          <Document
            file={url} 
            onLoadSuccess={onDocumentLoadSuccess} options={options} onLoadError={console.error} >
            {Array.from(new Array(numPages), (el, index) => (
              <Page scale={1.5} key={`page_${index + 1}`} pageNumber={index + 1} />
            ))}
          </Document>
          ): (
            <NoResults>
              { !url? (
                  <span>Não existe documento <BsXSquareFill /></span>
                ) : (
                  <TextLink href={url} target="_blank" >
                    Clique para acessar em nova aba &nbsp; <FaExternalLinkAlt size={15} />
                  </TextLink>
                )}
            </NoResults>
          )}
        </Body>*/}
      </Inner>
    </Content>
  );
}

const Content = styled.div<ContentProps>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  opacity: ${({ isOpen }) => isOpen ? 1 : 0};
  visibility: ${({ isOpen }) => isOpen ? 'visible' : 'hidden'};
  transition: all 0.2s;
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
`;

const Inner = styled.div`
  width: 100%;
  max-width: 1100px;
  min-height: 400px;
  background-color: ${({ theme }) => theme.colors.blue.dark};
  position: absolute;
  top: 240px;
  left: 50%;
  transform: translateX(-50%);
  padding: 32px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    width: calc(100% - 32px);
    top: 60px;
    padding: 16px;
  }
`;

const Close = styled.button`
  border: none;
  background:  ${({ theme }) => theme.colors.pink.light};
  color: ${({ theme }) => theme.colors.blue.dark};
  padding: 0;
  margin: 0;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(40%, -40%);
  cursor: pointer;

  > svg {
    display: block;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    transform: none;

    > svg {
      width: 32px;
      height: 32px;
    }
  }
`;

const Header = styled.div`
  display: flex;
  padding: 24px 80px;

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    padding: 16px 0;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    flex-direction: column;
  }
`;

const Item = styled.div`
  flex: 2;

  &:nth-child(2) {
    flex: 6;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    margin-bottom: 16px;
  }

  &:last-child {
    padding-left: 32px;

    @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
      padding-left: 40px;
    }

    @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
      padding-left: 0;
    }
  }
`;

const Title = styled.span`
  color: ${({ theme }) => theme.colors.pink.light};
  font-style: italic;
  font-size: 22px;
  margin-bottom: 16px;
  display: block;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    font-size: 18px;
    margin-bottom: 8px;
  }
`;

const ItemContent = styled.span`
  color: #fff;
  font-style: italic;
  font-size: 20px;
  font-weight: 300;

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    font-size: 16px;
  }
`;

const Body = styled.div<BodyProps>`
  overflow: auto;
  max-height: 80vh;
  background-color: ${({ theme }) => theme.colors.blue.dark};

  .react-pdf__Document {
    margin: 12px 0 64px 0;

    .react-pdf__message {
      color: #fff

    }
    @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
      margin: 0;
    }
  }

  canvas {
    margin: auto;
    width: 100% !important;
    height: auto !important;
    @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
      width: 100% !important;
      height: auto !important;
    }
  }
`;

const NoResults = styled.span`
  display: block;
  margin: 62px 0 20px 0;
  text-align: center;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.gray.light };
`;

const TextLinkBody = styled.span`
  display: block;
  margin: 0 0 12px 0;
  text-align: center;
  font-size: 18px;
  color: ${({ theme }) => theme.colors.gray.light };
`;

const TextLink = styled.a`
  border: 1px solid;
  color: ${({ theme }) => theme.colors.gray.light };
  padding: 0 10px;
  text-decoration: none;

  &:hover, &:active {
    opacity: 0.7;
  }

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    //display: flex;
  }
`;